import {Modal} from 'antd'
import {LoginContext} from 'components/LoginContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {CourseActionTypes} from '.'
import CourseContext from './CourseContext'
import {CourseRegisterForm} from './CourseSet/CourseRegisterForm'

const ModalLayout = ({ title, children, ...props }) => {
  const t = useTranslate()
  return (
    <Modal
      footer={null}
      destroyOnHidden={true}
      className="custom-modal"
      title={
          <div className="text-center font-bold text-sm md:text-lg text-color-000 uppercase tracking-wide">
              {_.isString(title) ? t(title) : title}
          </div>
      }
      {...props}>
      {children}
    </Modal>
  )
}

const withRouteModal =
  (params) =>
  (Component = NullAsDefault, props, withProps = NullAsDefault) =>
    (
      <LoginContext.Consumer>
        {(login) => (
          <CourseContext.Consumer>
            {({ item, current, handleAction, setCurrent = NullAsDefault }) => (
              <ModalLayout
                {...(params ?? {})}
                open={current}
                onCancel={() => {
                  setCurrent(null)
                }}>
                <Component
                  {...(props ?? {})}
                  {...(withProps({ item, login, handleAction }) ?? {})}
                />
              </ModalLayout>
            )}
          </CourseContext.Consumer>
        )}
      </LoginContext.Consumer>
    )

export const routes = {
  register: {
    path: 'register',
    name: 'register',
    component: () =>
      withRouteModal({
        title: 'register course',
        width: 700,
      })(CourseRegisterForm, {}, ({ handleAction = NullAsDefault }) => ({
        onSubmit: (values) => {
          handleAction(CourseActionTypes.REGISTER, values)
        },
      })),
    exact: true,
  },
}
